import React, { useEffect, useState, useRef, useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { LoadingScreen } from "../../../UiComponents/LoadingComponent";
import { Link, useLocation} from "react-router-dom";
import { useNavigate, useParams } from "react-router";
import { TopBar } from "../../../shared/topBar/TopBar";
import { BreadCrumbs } from "../../../shared/breadCrumbs/BreadCrumbs";
import { UrlPath } from "../../../../config/routeConfig";
import { GeneralEdit } from "./GeneralEdit";
import {GeneralInvestmentCompanyEdit} from "./GeneralInvestmentCompanyEdit";
import { AddressesEdit } from "./AddressesEdit";
import "../../../investor/investor.css";

export const CompanyEdit = (props) => {
  const locationData = useLocation();

  const dispatch = useDispatch();
  const params = useParams();

  const [loading, setLoading] = useState(true);
  const [selectedContactInfoButton, setContactInfoButton] = useState(locationData.state === null ? "" : locationData.state.selectedCompanyInfoButton);
  const [companyDetails, setCompanyDetails] = useState(locationData.state === null ? "" : locationData.state.companyData);
  const [contactTypeId,setcontactTypeId]=useState(locationData.state === null ? "" : locationData.state.ContactTypeId);
  const CompanyName = locationData?.state?.CompanyName;
  const queryParams = new URLSearchParams(locationData.search);
  const paramValue = queryParams.get('ContactTypeId'); 
  useEffect(() => {
    document.title = `Company Details`;
  }, []);

  useEffect(() => {
    setLoading(false);
  }, []);

  const contactName = companyDetails !== undefined ? companyDetails?.companyName : CompanyName;
  const edit = params.CompanyId !== "0" ? `${contactName} > Edit` : "";
  const addNew = params.CompanyId === "0" ?  "New Company" : "";

  let Level = [{ BreadCrumb: "Company > ", Routes: `${UrlPath.CompanyDetailsEdit}` }];

  Level = loading
    ? Level
    : [
        ...Level,
        {
          BreadCrumb: `${
            params.CompanyId !== "0"
              ? edit
              : addNew
          }`,
          Routes: `${
            params.CompanyId !== "0"
              ? UrlPath.InvestorDetails
              : UrlPath.Investor
          }${params.CompanyId !== "0" ? params.CompanyId : ""}`,
        },
      ];
  
  let editComponentToRender;
  let newEditTitleName;

    switch (selectedContactInfoButton) {
     
      case 1:
        newEditTitleName = "General Edit";
        editComponentToRender = paramValue==="1"?<GeneralEdit/>:<GeneralInvestmentCompanyEdit></GeneralInvestmentCompanyEdit>;
        break;
      case 2:
        newEditTitleName = "Addresses Edit";
        editComponentToRender = <AddressesEdit/>;
        break;     
      default:
        newEditTitleName = "General Edit";
        editComponentToRender = paramValue==="1"?<GeneralEdit/>:<GeneralInvestmentCompanyEdit></GeneralInvestmentCompanyEdit>;
        break;
    }

    return (
      <>
        {loading ? (
          <>
            <LoadingScreen />
          </>
        ) : (
          <>
            <TopBar label={"Company"} />
            <div id="content" className="asset-detail-screen">
              <BreadCrumbs Levels={Level} />
              <div className="container-fluid">
                <div className="header-container m-3">
                  <b>{newEditTitleName}</b>
                </div>
                {editComponentToRender}
              </div>
            </div>
          </>
        )}
      </>
    );
};
